import { useEffect, useRef, useState } from "react";
import { dispatchNotification } from "../../../../../layouts/app/components/notificationSystem/notifications";
import { DEBUG, DEPLOYMENTS_LOGS_STORAGE_NAME, URL_WEBSOCKET } from "../../../../../settings/global";
import { getCookie } from "../../../../../helpers/common";

function BuilderWebSocket({getDeployments}) {

    const [error, setError] = useState(null);
    const [socketIsReady, setSocketIsReady] = useState(false);
    const [showNotifications, setShowNotifications] = useState(true);

    const webSocket = useRef({
        onmessage: function () {},
        onerror: function () {},
        onclose: function () {}
    });
    const wsTimerId = useRef(null);

    const handleData = data => {

        let {message, alert, level, status, progress, id} = data;

        if (!alert) return;
        // show only first notification (usually about deployment start)
        if (showNotifications) {
            dispatchNotification({
                message, type: level || 'info',
            });
            setShowNotifications(false);
        }
        // show notifications about deployment status change during deployment process
        if (
            status === 'waiting_for_payment'
            || status === 'failed'
            || status === 'paused'
            || status === 'complete' && progress === 100
        ) {
            dispatchNotification({
                message, type: level || 'info',
            });
            getDeployments();
        }
        // collect and store deployments logs to be able to shaw them even on page refresh
        let logs = {...JSON.parse(localStorage.getItem(DEPLOYMENTS_LOGS_STORAGE_NAME))};
        let newLog = {message, status, progress, timestamp: Date.now()};
        let setLogs = newLogs => {
            localStorage.setItem(DEPLOYMENTS_LOGS_STORAGE_NAME, JSON.stringify(newLogs));
            // this method allows to live update logs in logs modal
            dispatchEvent(new Event("storage"));
        }

        if (!logs || !Object.keys(logs).length) { // create logs object if one is not found
            setLogs({[id]: [newLog]});
        } else { // update existing logs object
            let foundLog = logs[id];
            logs = {
                ...logs,
                ...{
                    [id]: !!foundLog && !!foundLog.length ? [...foundLog, ...[newLog]] : [newLog]
                }
            };
            // delete outdated logs to free up storage
            Object.keys(logs).map(log => {
                let msToDays = timestamp => timestamp / (1000 * 3600 * 24);
                if (logs[log].every(message => msToDays(Date.now() - message.timestamp) > 30)) {
                    delete logs[log];
                }
            })
            setLogs(logs)
        }

        getDeployments();
    };

    const openSocket = () => {
        webSocket.current.send('Socket is ready');
        setSocketIsReady(true);
    };

    const setupSocket = () => {
        let qid = getCookie('QID');
        const url = URL_WEBSOCKET + '/' + qid;
        webSocket.current = new WebSocket(url);
        webSocket.current.onopen = e => openSocket();
        webSocket.current.onmessage = e => handleData(JSON.parse(e.data));
        webSocket.current.onerror = e => {
            setError('WebSocket error');
            if (DEBUG) console.warn(e);
        }
        webSocket.current.onclose = e => {
            if (DEBUG) console.log('=== ws onclose event here ===');
            if (DEBUG) console.log(e);
            if (wsTimerId.current) clearTimeout(wsTimerId.current);
            if (!e.wasClean) {
                if (DEBUG) console.log('e.wasClean : ', e.wasClean);
                setError(`WebSocket error: ${e.code} ${e.reason}`);
            } else {
                if (DEBUG) console.log('ws reinitialised');
                setupSocket();
            }
        }
    };

    const keepWsAlive = () => {
        if (webSocket.current.readyState === webSocket.current.OPEN) webSocket.current.send('heartbeat');
        wsTimerId.current = setTimeout(
            () => keepWsAlive(),
            30000, // 30 sec
        );
    };

    useEffect(() => {
        if (!socketIsReady) setupSocket();
        keepWsAlive();

        return () => {
            clearTimeout(wsTimerId.current);
            // this.wsTimerId = null;
            webSocket.current.onmessage = function () {};
            webSocket.current.onerror = function () {};
            webSocket.current.onclose = function () {};
            if (webSocket.current.readyState === 1) {
                webSocket.current.onopen = function () {};
                webSocket.current.send("close");
                webSocket.current.close();
            }
            if (webSocket.current.readyState === 0) {
                webSocket.current.onopen = function () {
                    webSocket.current.send("close");
                    webSocket.current.close();
                };
            }
        }
    }, []);

    return null
}

export default BuilderWebSocket